import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { PagedResult, Segment } from 'app/core/interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QuerifyService } from '../services/querify.service';
import { Queries } from './graphql/queries';

@Injectable({
  providedIn: 'root'
})
export class SegmentApi {
  constructor(
    private apollo: Apollo,
    private queries: Queries,
    private querify: QuerifyService
  ) { }

  public search(query?, options?): Observable<PagedResult> {
    options = this.querify.transformOptions(query, options);
    return this.apollo
      .query({
        query: this.queries.segmentsPaginated(),
        variables: options
      })
      .pipe(
        map(({ data }) => {
          return data['segments'];
        })
      );
  }

  public async searchOne(maintenanceTypeId: string): Promise<Segment> {
    return this.apollo.query({
      query: this.queries.searchSegment(),
      variables: { id: maintenanceTypeId }
    }).toPromise()
      .then(({ data }) => {
        return data['segment'];
      });
  }
}
